import PropTypes from 'prop-types';
import React from 'react';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import t from '../../lib/I18n';
import _ from 'lodash';

import CustomerService from '../../services/CustomerService';
import ForgotPasswordForm from '../../records/customer/ForgotPasswordForm';
import ModalActions from '../../actions/ModalActions';
import { GlobalModals } from '../../constants/AppConstants';

import ValidatedField from '../form/ValidatedField';
import Icon from '../general/Icon';
import BaseModal from '../general/BaseModal';
import PureRenderComponent from '../PureRenderComponent';

class ForgotPasswordModal extends PureRenderComponent {

    static propTypes = {
        onCancel: PropTypes.func,
        isBrochureRedirect: PropTypes.bool,
    };

    static defaultProps = {
        onCancel: _.noop,
        isBrochureRedirect: false,
    };

    state = {
        form: new ForgotPasswordForm(),
        submitted: false,
        loading: false,
        success: false
    };

    _handleSelect = () => {
        if (!this.state.form.isComplete()) {
            this.setState({ submitted: true });
        } else {
            this.setState({ loading: true });

            const resetLinkQueryParams = this.props.isBrochureRedirect
                ? 'redirect=brochure'
                : null;

            CustomerService.requestResetPassword(this.state.form.email, resetLinkQueryParams).then(() => {
                this.setState({ loading: false, success: true });
            });
        }
    };

    _handleChange = (field, value) => {
        this.setState({
            form: this.state.form.set(field, value),
            submitted: false
        });
    };

    _handleCancel = () => {
        if (!this.state.success) {
            this.props.onCancel();
        }
        ModalActions.close(GlobalModals.FORGOT_PASSWORD);
    };

    _renderSuccess () {
        return (
            <div className="vertical-align-parent full-height">
                <div className="confirmation vertical-align text-center">
                    <Icon icon="selected" className="margin-bottom--sm otrl-xl" />
                    <p className="alert-success no-margin text-weight--normal">
                        { t('login.forgotPassword.submitted') }
                    </p>
                </div>
            </div>
        );
    }

    _renderForm () {
        return (
            <section>
                <Row>
                    <Col xs={ 12 }>
                        <p className="text-light margin-bottom">
                            { t('login.forgotPassword.help') }
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={ 12 }>
                        <ValidatedField
                            form={ this.state.form }
                            id="email"
                            field="email"
                            label={ t('customerdetails.email') }
                            labelClassName="sr-only"
                            placeholder={ t('customerdetails.email') }
                            onChange={ this._handleChange }
                            visited={ this.state.submitted }
                        />
                    </Col>
                </Row>
            </section>
        );
    }

    render () {
        const modalProps = {
            onClose: this._handleCancel,
            onContinue: this._handleSelect,
            className: 'modal--sm modal--standard',
            titleText: 'login.forgotPassword',
            disableContinue: this.state.loading,
            continueText: 'button.text.continue',
            closeText: this.state.success ? 'button.text.close' : 'button.text.cancel',
            hideContinue: this.state.success,
            onEnterContinue: false
        };

        return (
            <BaseModal { ...modalProps }>
                { this.state.success ? this._renderSuccess() : this._renderForm() }
            </BaseModal>
        );
    }

}


export default ForgotPasswordModal;



// WEBPACK FOOTER //
// ./src/components/login/ForgotPassword.js